<template>
  <img
    class="scale-x-[-1]"
    src="./logo.svg"
    alt="Logo"
  />
</template>
